import React, { Component } from "react";
import { withCookies, Cookies } from "react-cookie";
import { instanceOf } from "prop-types";
import { withRouter } from "react-router-dom";

// Services
import productsService from '@services/products';
import postosService from '@services/postos';

import "react-confirm-alert/src/react-confirm-alert.css";
import "./combustivel.css";

// Components
import Menu from "@components/Menu";
import Button from "@components/Button";
import Checkbox from "@components/CheckBox";

import { currentDateTime } from "@utils/date";

import UserContext from "@components/context/userContext";

const defaultDate = currentDateTime();

class Page extends Component {
  static contextType = UserContext;

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      warehouses: [],
      date: defaultDate,
      samePrices: false,
      products: [],
      values: {
        columns: [
          {
            label: "Data",
            field: "date",
            width: 200,
          },
          {
            label: "Produto",
            field: "product",
            width: 300,
          },
          {
            label: "Price",
            field: "price",
            width: 200,
          },
        ],
        rows: [],
      },
    };
    this.loadFunction = this.loadFunction.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  async loadFunction() {
    if (!this.state.loaded) {
      const profile = this.context;

      try {
        const [warehousesData, postosProductsData, productsData] = await Promise.all([
          postosService.get(profile.idEmpresa),
          productsService.getPostoProductsByFilter(profile.idEmpresa, true, "pv.sync='TRUE'"),
          productsService.getWithFilter(profile.idEmpresa, { combustivel: true })
        ]);

        const warehouses = warehousesData !== "NOK"
          ? warehousesData.reduce(
              (accum, warehouse) => ({
                ...accum,
                [warehouse.posto]: warehouse,
              }),
              {}
            )
          : {};

        const postosWarehouses = postosProductsData !== "NOK" ? postosProductsData : {};
        const products = productsData !== "NOK" ? productsData : [];

        const warehousesList = Object.keys(warehouses).map((warehouse) => ({
          ...warehouses[warehouse],
          date: defaultDate,
          idposto: warehouse,
          total: postosWarehouses[warehouse]?.total,
          products: postosWarehouses[warehouse]?.items?.map(
            (product) => ({
              ...product,
            })
          ) || [],
        }));

        this.setState({
          warehouses: warehousesList,
          products: products.map((product) => ({
            ...product,
            price: "",
          })),
          loaded: true,
        });
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
      }
    }
  }

  handleChange(e, callback) {
    let value = e.target.value;
    let name = e.target.name;

    let newState = this.state;

    if (name.includes("|")) {
      const properties = name.split("|");

      if (properties[4]) {
        newState[properties[0]][properties[1]][properties[2]][properties[3]][
          properties[4]
        ] = value;
      } else if (properties[2]) {
        newState[properties[0]][properties[1]][properties[2]] = value;
      }

      this.setState({
        ...newState,
      });
    } else {
      if (name === "samePrices") {
        this.setState({
          [name]: !newState[name],
        });
      } else {
        this.setState({
          [name]: value,
        });
      }
    }
  }


  getWarehouseStats(warehouse) {
    const productsWithPrices = warehouse.products.filter(p => p.price && p.price !== "");
    const totalProducts = warehouse.products.length;
    const configuredProducts = productsWithPrices.length;
    
    return {
      total: totalProducts,
      configured: configuredProducts,
      pending: totalProducts - configuredProducts,
      percentage: totalProducts > 0 ? Math.round((configuredProducts / totalProducts) * 100) : 0
    };
  }

  executeSequentially(promiseLikeArray) {
    var result = Promise.resolve();
    promiseLikeArray.forEach(function (promiseLike) {
      result = result.then(promiseLike);
    });
    return result;
  }

  async handleFormSubmit() {
    const { history } = this.props;
    const profile = this.context;
    const { warehouses, products } = this.state;

    try {
      if (this.state.samePrices) {
        // Para preços globais, precisamos aplicar o mesmo preço a todos os postos
        const productsWithPrices = products.filter(({ price }) => price !== "" && price !== null);
        
        const promises = productsWithPrices.map(async (product) => {
          // Encontrar todos os warehouses que têm este produto
          const productInWarehouses = [];
          
          warehouses.forEach((warehouse, warehouseIndex) => {
            const warehouseProduct = warehouse.products.find(
              (wp) => wp.idproduct === product.idproduct
            );
            if (warehouseProduct) {
              productInWarehouses.push({
                ...warehouseProduct,
                price: product.price
              });
            }
          });

          if (productInWarehouses.length > 0) {
            await productsService.setPrices({
              idempresa: profile.idEmpresa,
              idproduct: product.idproduct,
              values: productInWarehouses,
            });
          }
        });

        await Promise.all(promises);
      } else {
        // Para preços individuais por posto
        const requestProducts = warehouses.reduce(
          (acc, warehouse) => {
            warehouse.products.forEach((warehouseProduct) => {
              if (warehouseProduct.price && warehouseProduct.price !== "") {
                if (acc[warehouseProduct.idproduct]) {
                  acc[warehouseProduct.idproduct] = [
                    ...acc[warehouseProduct.idproduct],
                    warehouseProduct,
                  ];
                } else {
                  acc[warehouseProduct.idproduct] = [warehouseProduct];
                }
              }
            });
            return acc;
          },
          {}
        );

        const allPromises = Object.keys(requestProducts).map((productId) =>
          productsService.setPrices({
            idempresa: profile.idEmpresa,
            idproduct: productId,
            values: requestProducts[productId],
          })
        );

        await Promise.all(allPromises);
      }
      
      history.push("/products/sync");
    } catch (error) {
      console.error('Erro ao guardar preços:', error);
    }
  }

  render() {
    const { loaded, warehouses, samePrices, products } = this.state;
    const { location, history } = this.props;
    const cookies = new URLSearchParams(location.search);

    return (
      <div className="combustivel-page">
        <Menu
          loadFunction={this.loadFunction}
          location={location}
          history={history}
          newCookies={cookies}
        />
        
        {/* Breadcrumb */}
        <div className="fullContainer">
          <div className="col-xs-12">
            <nav className="breadcrumb-nav">
              <ol className="breadcrumb-list">
                <li className="breadcrumb-item">
                  <a href="http://eposgestofinal.com/index.php" className="breadcrumb-link">Portal</a>
                </li>
                <li className="breadcrumb-separator">›</li>
                <li className="breadcrumb-item">Preços</li>
                <li className="breadcrumb-separator">›</li>
                <li className="breadcrumb-item active">Combustíveis</li>
              </ol>
            </nav>
          </div>
        </div>

        {/* Main Content */}
        <div className="fullContainer">
          <div className="col-sm-12">
            {loaded && (
              <div className="main-panel">
                {/* Header */}
                <div className="panel-header">
                  <h1 className="panel-title">
                    <span className="title-icon" role="img" aria-label="ícone de combustível">⛽</span>
                    Preços de Combustíveis
                  </h1>
                  <p className="panel-subtitle">Configure os preços dos combustíveis para cada posto</p>
                </div>

                {/* Options */}
                <div className="options-section">
                  <div className="option-card">
                    <div className="option-content">
                      <div className="checkbox-container">
                        <Checkbox
                          key={"samePrices"}
                          name={"samePrices"}
                          title={"Aplicar preços iguais em todos os postos"}
                          checked={samePrices}
                          handleChange={this.handleChange}
                        />
                      </div>
                      <div className="option-description">
                        <h4>Preços Globais</h4>
                        <p>Define o mesmo preço para cada produto em todos os postos</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="content-section">
                  {samePrices ? (
                    <div className="global-prices-container">
                      <div className="section-header">
                        <h2>Preços Globais dos Produtos</h2>
                        <p>Estes preços serão aplicados a todos os postos</p>
                      </div>
                      <div className="global-products-grid">
                        {products.sort((a, b) => a.idproduct.localeCompare(b.idproduct)).map((product, indexP) => (
                          <div key={`global-${indexP}`} className="global-product-card">
                            <div className="product-badge">#{product.idproduct}</div>
                            <div className="product-details">
                              <h3 className="product-title">{product.nome}</h3>
                              <div className="price-input-wrapper">
                                <label className="input-label">Preço (€)</label>
                                <input
                                  type="number"
                                  className="modern-input"
                                  step="0.01"
                                  min="0"
                                  placeholder="0.00"
                                  key={`products|${indexP}|price`}
                                  name={`products|${indexP}|price`}
                                  value={product.price}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="warehouses-container">
                      <div className="section-header">
                        <h2>Preços por Posto</h2>
                        <p>Configure os preços individuais para cada posto</p>
                      </div>
                      
                      {/* Cards de Postos com Produtos */}
                      <div className="warehouses-grid">
                        {warehouses.map((warehouse, warehouseIndex) => {
                          const stats = this.getWarehouseStats(warehouse);
                          
                          return (
                            <div key={warehouse.posto} className="warehouse-card-with-products">
                              {/* Header do Posto */}
                              <div className="warehouse-card-header">
                                <div className="warehouse-header-content">
                                  <div className="warehouse-badge">#{warehouse.posto}</div>
                                  <h3 className="warehouse-title">{warehouse.nome}</h3>
                                </div>
                                <div className="warehouse-summary">
                                  <div className={`warehouse-status ${stats.percentage === 100 ? 'complete' : stats.percentage > 0 ? 'partial' : 'pending'}`}>
                                    {stats.percentage === 100 ? '✓' : stats.percentage > 0 ? '⚠' : '○'}
                                  </div>
                                  <span className="warehouse-count">{stats.configured}/{stats.total}</span>
                                </div>
                              </div>

                              {/* Produtos do Posto */}
                              <div className="warehouse-products">
                                {warehouse.products.sort((a, b) => a.idproduct.localeCompare(b.idproduct)).map((product, productIndex) => (
                                  <div key={`${warehouse.posto}-${productIndex}`} className="product-card">
                                    <div className="product-info">
                                      <div className="product-id">#{product.idproduct}</div>
                                      <div className="product-name">{product.name}</div>
                                    </div>
                                    <div className="price-input-container">
                                      <label className="price-label">Preço (€)</label>
                                      <input
                                        type="number"
                                        className="price-input"
                                        step="0.01"
                                        min="0"
                                        placeholder="0.00"
                                        key={`warehouses|${warehouseIndex}|products|${productIndex}|price`}
                                        name={`warehouses|${warehouseIndex}|products|${productIndex}|price`}
                                        value={product.price}
                                        onChange={this.handleChange}
                                      />
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>

                {/* Actions */}
                <div className="actions-section">
                  <div className="actions-container">
                    <Button
                      action={this.handleFormSubmit}
                      type={"success"}
                      title={"Guardar e Sincronizar"}
                      style={{
                        padding: '15px 30px',
                        fontSize: '16px',
                        fontWeight: '600'
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

      </div>
    );
  }
}

export default withCookies(withRouter(Page));
